module.exports = __webpack_public_path__ + "img/phoneBanner4.cec600c2.jpg";